import Permission from 'owa-service/lib/contract/Permission';
import PermissionLevelType from 'owa-service/lib/contract/PermissionLevelType';
import { getPermissionLevelToLocaleArray } from './permissionLevelLocaleStrings';
import getPermissionFromPermissionLevel from './getPermissionFromPermissionLevel';
import PERMISSION_CONSTANTS from '../utils/permissionConstants';

/**
 * Function returns permission level by comparing permission object with predefined permission objects.
 * If the passed permission is matched to any predefined permission objects then Permission level of that matching object is returned else 'Custom' is returned.
 * @param permission Object containing permissions assigned to an user.
 * @returns PermissionLevelType
 */
export default function getPermissionLevelFromPermission(
    permission: Permission
): PermissionLevelType {
    const permissionLevelToLocaleArray = getPermissionLevelToLocaleArray();
    for (const permissionLevelObj of permissionLevelToLocaleArray) {
        // Do not match for 'Custom' permission level as it is going to be returned
        // If the current permission object do not match with any other permission level.
        if (permissionLevelObj.key === PERMISSION_CONSTANTS.PERMISSION_LEVEL_TYPE.CUSTOM) {
            continue;
        }
        const permissionObj = getPermissionFromPermissionLevel(permissionLevelObj.key);
        if (arePermissionsEqual(permissionObj, permission)) {
            return permissionObj.PermissionLevel;
        }
    }
    return PERMISSION_CONSTANTS.PERMISSION_LEVEL_TYPE.CUSTOM;
}

/**
 * Function checks if the permissions have same values for respective properties (expect for PermissionLevel).
 * @param permission1 First permission object
 * @param permission2 Second permission object
 * @returns If the passed permissions are similar or not.
 */
function arePermissionsEqual(permission1: Permission, permission2: Permission): boolean {
    const keys = Object.keys(permission1);
    for (const key of keys) {
        if (key === PERMISSION_CONSTANTS.PROPERTY.IS_FOLDER_CONTACT) {
            // Permission level of Owner/None type can have any value for IsFolderContact property.
            if (
                permission1.PermissionLevel === PERMISSION_CONSTANTS.PERMISSION_LEVEL_TYPE.OWNER ||
                permission1.PermissionLevel === PERMISSION_CONSTANTS.PERMISSION_LEVEL_TYPE.NONE
            ) {
                continue;
            }
        }
        if (key === PERMISSION_CONSTANTS.PROPERTY.IS_FOLDER_VISIBLE) {
            // Permission level of None type can have any value for IsFolderVisible property.
            if (permission1.PermissionLevel === PERMISSION_CONSTANTS.PERMISSION_LEVEL_TYPE.NONE) {
                continue;
            }
        }
        // We just have to match other properties present in the permission object except 'PermissionLevel'
        if (key === PERMISSION_CONSTANTS.PROPERTY.PERMISSION_LEVEL) {
            continue;
        }
        if (permission1[key] !== permission2[key]) {
            return false;
        }
    }
    return true;
}
